import React, { useEffect } from 'react'
import AdminDashboardLayout from './AdminDashboardLayout'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { getSingleCorporatesAPI } from '../../redux/slices/superAdminCorporateSlice'
import { base } from '../../constants/base'

const CorporateVIewPage = () => {

    const dispatch = useDispatch()
    const loading = useSelector(state => state.SuperAdminCorporateSlice.loading)
    const singleCorporate = useSelector(state => state.SuperAdminCorporateSlice.singleCorporate)
    const param = useParams()
    const id = param?.id;

    const fetchSingleCorporate = async () => {
        const res = await dispatch(getSingleCorporatesAPI(id))
    }

    useEffect(() => {
        fetchSingleCorporate()
    }, [id])


    return (
        <>
            <AdminDashboardLayout>
                {loading ? <div className="loading-center-on-page">
                    <i
                        style={{ fontSize: "52px" }}
                        className="fa-solid fa-spinner fa-spin"
                    ></i>
                </div> : <div className={`blue-bg-box-main ${singleCorporate?.status === "Active" ? 'active-border-color' : "block-border-box"}`}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="container">
                                    <div className="row">

                                        <div className="col-md-12">
                                            <div className="company-data">
                                                <h3 className={`${singleCorporate?.status === "Active" ? 'active-box' : "block-box"}`}> {singleCorporate?.status}</h3>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-user"></i> Company Name</h3>
                                                <p>{singleCorporate?.name}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-envelope"></i> Email Address</h3>
                                                <p>{singleCorporate?.email}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-phone"></i> Phone Number</h3>
                                                <p>{singleCorporate?.phone_no}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i className='fa-solid fa-briefcase'></i> Company EIN Number</h3>
                                                <p>{singleCorporate?.ein_number}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i className='fa-solid fa-shield-halved'></i> Tax ID Number</h3>
                                                <p>{singleCorporate?.tax_id_number}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-hashtag"></i> Work Permit ID</h3>
                                                <p>{singleCorporate?.work_permit_id}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-address-book"></i> Registration Number</h3>
                                                <p>{singleCorporate?.registration_number}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-address-card"></i> Social Security Number</h3>
                                                <p>{singleCorporate?.ss_number}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-location-dot"></i> Address</h3>
                                                <p>{singleCorporate?.address?.address}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-signature"></i> About Company</h3>
                                                <p>{singleCorporate?.about}</p>
                                            </div>
                                        </div>

                                        <div className="col-md-6">
                                            <div className="company-data">
                                                <h3><i class="fa-solid fa-file"></i> Other Document</h3>
                                                <p><a href={`${base.imageUrl}${singleCorporate?.images?.[1]?.path}`} target='_blank'>See Document</a></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="profile-image-corporate">
                                    <img src={`${base.imageUrl}${singleCorporate?.images?.[0]?.path}`} alt="Profile" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
            </AdminDashboardLayout>
        </>
    )
}

export default CorporateVIewPage